module.exports = __webpack_public_path__ + "img/SketchPng47190e2cd27354a017a64ae9598b7ae32351c46eb2bd55f92244025eb58fc14c.b245e9ee.png";